export default "__VITE_ASSET__b11fc395__"